import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../../i18n/i18n';
import { Button, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { SketchPicker } from 'react-color';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setInitialState, addImplementSubgroup, getGroup } from '../../../actions/resources/ImplementsActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Modal from '@material-ui/core/Modal';
import DialogTitle from '@material-ui/core/DialogTitle';
export class AddImplementsSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            implementSubgroupObj: this.props.implementSubgroupObj,
            openModal: false,
            displayColorPicker: false
        }
    }

    componentDidMount() {
        if (this.props.implementGroupDropdown.length === 0) {
            this.props.getGroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.implementSubgroupPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('implementSubgroupPostingFailed');
        }
    }

    addImplementSubgroup() {
        if (this.state.implementSubgroupObj.naziv
            && this.state.implementSubgroupObj.id_prikljucna_masina_grupa) {
            this.props.addImplementSubgroup(
                this.state.implementSubgroupObj
            )

        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }

    handleChangeComplete = (color) => {
        let obj = Object.assign({}, this.state.implementSubgroupObj);
        obj.boja = color.hex;
        this.setState({ implementSubgroupObj: obj });
    };

    handleChangeValue = name => event => {
        let obj = Object.assign({}, this.state.implementSubgroupObj);
        obj[name] = event.target.value;
        this.setState({ implementSubgroupObj: obj });
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, openModal: !this.state.openModal })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, openModal: false })
    };


    render() {
        let group = [];
        if (this.props.implementGroupDropdown && !this.props.groupFetching) {
            group = this.props.implementGroupDropdown.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>

                {/* <Paper className="roundedBoxMaterial" zdepth={4}> */}
                <Dialog
                    open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="xs"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit Implement subgroup') : i18n.t('Add Implement subgroup')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-implement-subgroup">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16}>
                                <Grid item>
                                    <TextField
                                        select
                                        label={"Implement group"}
                                        value={this.state.implementSubgroupObj.id_prikljucna_masina_grupa}
                                        onChange={this.handleChangeValue('id_prikljucna_masina_grupa')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        required
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    >
                                        <option value='' />
                                        {group}
                                    </TextField>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        required
                                        label={i18n.t('Title')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.implementSubgroupObj.naziv}
                                        onChange={this.handleChangeValue('naziv')} />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Icon name')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.implementSubgroupObj.ime_ikonice}
                                        onChange={this.handleChangeValue('ime_ikonice')} />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Priority')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.implementSubgroupObj.prioritet}
                                        onChange={this.handleChangeValue('prioritet')} />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Color')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px', backgroundColor: this.state.implementSubgroupObj.boja && this.state.implementSubgroupObj.boja.includes('#') ? `${this.state.implementSubgroupObj.boja}` : `#${this.state.implementSubgroupObj.boja}` }}
                                        onClick={this.handleClick}
                                        value={this.state.implementSubgroupObj.boja}
                                    >
                                    </TextField>
                                    {this.state.displayColorPicker ? <div style={{
                                        position: 'absolute',
                                        zIndex: '2',
                                    }}>
                                        <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={this.state.openModal}
                                            onClose={this.handleClose}
                                            style={{
                                                position: 'absolute',
                                                left: '50%',
                                                top: '50%',
                                                right: '50%',
                                                bottom: '50%',
                                            }}
                                        >
                                            <SketchPicker color={this.state.implementSubgroupObj.boja != null ? this.state.implementSubgroupObj.boja : ''} onChange={this.handleChangeComplete} />
                                        </Modal>
                                    </div> : null}
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white' }}
                                        onClick={() => this.addImplementSubgroup()}
                                    >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
                {/* </Paper> */}
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        implementGroupDropdown: state.implementReducer.implementGroupDropdown,
        groupFetching: state.implementReducer.groupFetching,
        groupFetchingFailed: state.implementReducer.groupFetchingFailed,
        implementSubgroupObj: state.implementReducer.implementSubgroupObj,
        implementSubgroupPosting: state.implementReducer.implementSubgroupPosting,
        implementSubgroupPostingFailed: state.implementReducer.implementSubgroupPostingFailed
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addImplementSubgroup: (implementSubgroupObj) => dispatch(addImplementSubgroup(implementSubgroupObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddImplementsSubgroup)